"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrillantExcelField = void 0;
var BrillantExcelField;
(function (BrillantExcelField) {
    BrillantExcelField["groesse"] = "Brillantgr\u00F6\u00DFe";
    BrillantExcelField["twsi"] = "TW/SI";
    BrillantExcelField["wsi"] = "W/SI";
    BrillantExcelField["twif"] = "TW/IF (Lupenrein)";
    BrillantExcelField["princess"] = "Princess";
    BrillantExcelField["siSchwarz"] = "SI Schwarz";
    BrillantExcelField["siBlau"] = "SI Blau";
    BrillantExcelField["siGruen"] = "SI Gr\u00FCn";
    BrillantExcelField["siBraun"] = "SI Braun";
    BrillantExcelField["siGelb"] = "SI Gelb";
    BrillantExcelField["rubin"] = "Rubin";
    BrillantExcelField["saphir"] = "Saphir";
    BrillantExcelField["smaragd"] = "Smaragd";
    BrillantExcelField["zirkonia"] = "Zirkonia";
})(BrillantExcelField = exports.BrillantExcelField || (exports.BrillantExcelField = {}));
//# sourceMappingURL=BrillantExcelField.js.map